<div class="body">
  <div class="container" style="height: 100px"></div>

  <div class="container principal">
    <div class="col-lg-12" style="font: 400 18px/20px Roboto">
      <h2>
       
        Por favor, responda las siguientes preguntas, para luego ejercer su voto con el fin de elegir al representante de los
          afiliados y afiliadas en el Consejo Administrativo del Servicio de Bienestar. Recuerde que puede votar sólo una vez.
       
      </h2>
    </div>

    <div class="form-container">
      <h2>Elecciones Consejo Administrativo Bienestar</h2>
      <p class="required">* Obligatorio</p>
    

      <div *ngFor="let pregunta of preguntas" class="question">
        <label class="question-title">{{ pregunta.id }}. {{ pregunta.nombre }} *</label>
        <div class="radio-group">
          <label *ngFor="let opcion of pregunta.opcion">
            <input type="radio" [name]="'pregunta_' + pregunta.id" [value]="opcion.id" [(ngModel)]="seleccionRespuestas[pregunta.id]" />
            {{ opcion.nombre }}
          </label>
        </div>
      </div>

      <button class="btn-siguiente" (click)="enviarVotacion()">Enviar</button>
    </div>
  </div>
</div>